export const ReactionResolveOption = {
    Invite : 0,
    Reject : 1
}